import React from 'react';

import HGeneric from '../helpers/HGeneric';
import CLocalizedTextStringStatic from './CLocalizedTextStringStatic';

interface Props {
  timestamp: Date | undefined | 0;
}

export default function TimestampComponent(props: Props) {
  const updatedAtLabel = CLocalizedTextStringStatic('global.updatedAt');
  return (
    <>
      {props.timestamp !== undefined && props.timestamp !== 0 && (
        <>
          {updatedAtLabel}&nbsp;
          {HGeneric.formatString(props.timestamp.toISOString(), {
            in: 'tzTimestamp',
            out: 'localeTimeString'
          })}
        </>
      )}
    </>
  );
}
